import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useConnectorDataStreamsQueryV1(connectorId?: string | Ref<string>, ) {
	const _connectorId = isRef<string>(connectorId) ? connectorId : ref<string>(connectorId)
	const result = {
		connectorId: _connectorId,
		...useQuery(() => new q.ConnectorDataStreamsQueryV1(_connectorId.value))
	}
	return {
		...result,
		runConnectorDataStreamsQueryV1: result.run,
		modelConnectorDataStreamsQueryV1: result.model,
	}
}

export function useConnectorDetailsQueryV1(connectorId?: string | Ref<string>, ) {
	const _connectorId = isRef<string>(connectorId) ? connectorId : ref<string>(connectorId)
	const result = {
		connectorId: _connectorId,
		...useQuery(() => new q.ConnectorDetailsQueryV1(_connectorId.value))
	}
	return {
		...result,
		runConnectorDetailsQueryV1: result.run,
		modelConnectorDetailsQueryV1: result.model,
	}
}

export function useConnectorPropertyNamesQueryV1(connectorId?: string | Ref<string>, dataStream?: string | Ref<string>, ) {
	const _connectorId = isRef<string>(connectorId) ? connectorId : ref<string>(connectorId)
	const _dataStream = isRef<string>(dataStream) ? dataStream : ref<string>(dataStream)
	const result = {
		connectorId: _connectorId,
		dataStream: _dataStream,
		...useQuery(() => new q.ConnectorPropertyNamesQueryV1(_connectorId.value, _dataStream.value))
	}
	return {
		...result,
		runConnectorPropertyNamesQueryV1: result.run,
		modelConnectorPropertyNamesQueryV1: result.model,
	}
}

export function useConnectorProvidersQueryV1(canRead?: boolean | Ref<boolean>, canWrite?: boolean | Ref<boolean>, ) {
	const _canRead = isRef<boolean>(canRead) ? canRead : ref<boolean>(canRead)
	const _canWrite = isRef<boolean>(canWrite) ? canWrite : ref<boolean>(canWrite)
	const result = {
		canRead: _canRead,
		canWrite: _canWrite,
		...useQuery(() => new q.ConnectorProvidersQueryV1(_canRead.value, _canWrite.value))
	}
	return {
		...result,
		runConnectorProvidersQueryV1: result.run,
		modelConnectorProvidersQueryV1: result.model,
	}
}

export function useConnectorsOfOrganizationQueryV1(organizationUnitId?: string | Ref<string>, rebuild?: boolean | Ref<boolean>, ) {
	const _organizationUnitId = isRef<string>(organizationUnitId) ? organizationUnitId : ref<string>(organizationUnitId)
	const _rebuild = isRef<boolean>(rebuild) ? rebuild : ref<boolean>(rebuild)
	const result = {
		organizationUnitId: _organizationUnitId,
		rebuild: _rebuild,
		...useQuery(() => new q.ConnectorsOfOrganizationQueryV1(_organizationUnitId.value, _rebuild.value))
	}
	return {
		...result,
		runConnectorsOfOrganizationQueryV1: result.run,
		modelConnectorsOfOrganizationQueryV1: result.model,
	}
}

